module.exports = __webpack_public_path__ + "static/media/img9.6d7f3f0d.jpg";